import PropTypes from "prop-types";

import { DesktopIcon } from "assets/icons";
import { useIsMobile } from "hooks/useIsMobile";
import {
  DesktopOnlyContainer,
  IconWrapper,
  MessageContainer,
  Title,
  Description,
} from "./DesktopOnly.styles";

const DEFAULT_TITLE = "Please use desktop for a better experience";
const DEFAULT_DESCRIPTION =
  "Creating and managing strategies isn't available on mobile yet. Visit Surmount on your desktop to build strategies.";

// Renders children on desktop; on mobile web shows a "use desktop" message instead.
export const DesktopOnly = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  children,
}) => {
  const isMobile = useIsMobile();

  if (!isMobile) return children;

  return (
    <DesktopOnlyContainer>
      <IconWrapper>
        <DesktopIcon />
      </IconWrapper>
      <MessageContainer>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </MessageContainer>
    </DesktopOnlyContainer>
  );
};

DesktopOnly.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
};
